<div class="container-fluid" style="height: calc(100vh - 56px); padding: 0">
    <mat-sidenav-container class="reports-sidenav-container" style="width: 100%; height: 100%;">
        <mat-sidenav #sidenav mode="side" [class.mat-elevation-z4]="true" class="reports-sidenav" opened="true"
            disableClose="true">
            <mat-nav-list>
                <mat-list-item [routerLink]="['admin-dashboard']" [routerLinkActive]="['active-reports-link']">
                    <span style="display: flex; align-items: center">
                        <mat-icon>dashboard</mat-icon><span class="sideNavSpan">Assign Collectors</span>
                    </span>
                </mat-list-item>
                <mat-list-item [routerLinkActive]="['active-reports-link']" [routerLink]="['locked-accounts']">
                    <span style="display: flex; align-items: center">
                        <mat-icon>lock</mat-icon><span class="sideNavSpan">Locked Accounts</span>
                    </span>
                </mat-list-item>
                <mat-list-item [routerLinkActive]="['active-reports-link']" [routerLink]="['account']">
                    <span style="display: flex; align-items: center">
                        <mat-icon>group</mat-icon><span class="sideNavSpan">Accounts</span>
                    </span>
                </mat-list-item>
                <mat-list-item [routerLinkActive]="['active-reports-link']" [routerLink]="['external-client-api']">
                    <span style="display: flex; align-items: center">
                        <mat-icon>business</mat-icon><span class="sideNavSpan">External Client APIs</span>
                    </span>
                </mat-list-item>
				<mat-list-item [routerLinkActive]="['active-reports-link']" [routerLink]="['debugging']">
					<span style="display: flex; align-items: center">
						<mat-icon style="
								margin-right: 5px;
								height: 16px;
								width: 16px;
								font-size: 16px;
							">bug_report</mat-icon><span style="
								width: 100%;
								overflow: hidden;
								text-overflow: ellipsis;
								font-size: 14px;
							">Debugging</span>
					</span>
                </mat-list-item>
                <mat-list-item [routerLinkActive]="['active-reports-link']" [routerLink]="['payment-processing']">
                    <span style="display: flex; align-items: center">
                        <mat-icon>payment</mat-icon><span class="sideNavSpan">Payment Processing</span>
                    </span>
                </mat-list-item>
                <mat-list-item [routerLinkActive]="['active-reports-link']" [routerLink]="['agreements']">
                    <span style="display: flex; align-items: center">
                        <mat-icon>handshake</mat-icon><span class="sideNavSpan">Agreements</span>
                    </span>
                </mat-list-item>
                <mat-list-item [routerLinkActive]="['active-reports-link']" [routerLink]="['apps-conversion']">
                    <span style="display: flex; align-items: center">
                        <mat-icon>leaderboard</mat-icon><span class="sideNavSpan">Apps Conversion</span>
                    </span>
                </mat-list-item>
                <mat-list-item [routerLinkActive]="['active-reports-link']" [routerLink]="['promise-to-pay']">
                    <span style="display: flex; align-items: center">
                        <mat-icon>event_available</mat-icon><span class="sideNavSpan">Promise to Pay</span>
                    </span>
                </mat-list-item>
                <mat-list-item [routerLinkActive]="['active-reports-link']" [routerLink]="['application-permissions']">
                    <span style="display: flex; align-items: center">
                        <mat-icon>admin_panel_settings</mat-icon><span class="sideNavSpan">Application Permissions</span>
                    </span>
                </mat-list-item>
            </mat-nav-list>
        </mat-sidenav>
        <mat-sidenav-content>
            <div (click)="sidenav.toggle(); toggleSideNav()" class="sidenav-toggle-button"
                [ngClass]="isSideNavMenuOpen ? 'sidenav-open' : 'sidenav-closed'">
                <div class="icon-bar" [@sideNavMenuAnimationState]="isSideNavMenuOpen ? 'line' : 'topX'"></div>
                <div class="icon-bar" [@sideNavMenuAnimationState]="isSideNavMenuOpen ? 'line' : 'hide'"></div>
                <div class="icon-bar" [@sideNavMenuAnimationState]="isSideNavMenuOpen ? 'line' : 'bottomX'"></div>
            </div>
            <router-outlet> </router-outlet>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>